import { Box } from "@mui/material";

interface Props {
	src: string;
	onVideoEnd: () => void;
}

export const CustomerVideo = ({ src, onVideoEnd }: Props) => {
	return (
		<Box
			sx={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				backgroundColor: "black",
				zIndex: 9999,
			}}
		>
			{/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
			<video
				autoPlay
				onEnded={onVideoEnd}
				style={{
					width: "100%",
					height: "100%",
					objectFit: "cover",
				}}
			>
				<source src={src} type="video/mp4" />
			</video>
		</Box>
	);
};
